import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { RootState } from '@root/app.state';
import * as PlatformActions from '@platform/platform.actions';
import { openDirectoryApi, openDirectoryWebkitInput } from '@platform/shared/utilities/open-directory-utility';

@Component({
  selector: 'app-profile-picture-upload-dialog',
  templateUrl: './profile-picture-upload-dialog.component.html',
  styleUrls: ['./profile-picture-upload-dialog.component.scss'],
})
export class ProfilePictureUploadDialogComponent implements OnInit {
  multiple = true;
  constructor(
    private dialogRef: MatDialogRef<ProfilePictureUploadDialogComponent>,
    private store$: Store<RootState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.multiple = false;
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  enter($event: any) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  ngOnInit(): void {}

  public uploadFile(event: FileList) {
    this.store$.dispatch(PlatformActions.closeDialog({ id: this.dialogRef.id, data: event }));
  }

  public uploadFileFromEvent(event: Event) {
    this.store$.dispatch(PlatformActions.closeDialog({ id: this.dialogRef.id, data: (event.target as any).files }));
  }

  public uploadFilesFromList(iFiles: FileList) {
    this.store$.dispatch(PlatformActions.closeDialog({ id: this.dialogRef.id, data: iFiles }));
  }

  public closeDialog(): void {
    this.store$.dispatch(PlatformActions.closeDialog({ id: this.dialogRef.id }));
  }

  async openDirectoryPicker(): Promise<void> {
    let filesInDirectory: FileList | undefined;
    if (this.isOpera()) {
      filesInDirectory = await openDirectoryApi('read', ['.DS_Store']);
    } else {
      filesInDirectory = await openDirectoryWebkitInput();
    }
    if (!filesInDirectory) {
      return;
    }
    // Array.from(filesInDirectory).forEach((file) => console.log(`${file.name}\n`));
    this.uploadFilesFromList(filesInDirectory);
  }

  isOpera(): boolean {
    const userAgent = window.navigator.userAgent;
    return userAgent.indexOf('OPR') !== -1 || userAgent.indexOf('Opera') !== -1;
  }

  isChrome(): boolean {
    // please note,
    // that IE11 now returns undefined again for window.chrome
    // and new Opera 30 outputs true for window.chrome
    // but needs to check if window.opr is not undefined
    // and new IE Edge outputs to true now for window.chrome
    // and if not iOS Chrome check
    // so use the below updated condition
    const isChromium = 'chrome' in window; // window.chrome;
    const winNav = window.navigator;
    // eslint-disable-next-line deprecation/deprecation
    const vendorName = winNav.vendor;
    const isOpera = typeof (window as any).opr !== 'undefined';
    const isIEedge = winNav.userAgent.indexOf('Edg') > -1;
    const isIOSChrome = winNav.userAgent.match('CriOS');

    if (isIOSChrome) {
      // is Google Chrome on IOS
      return true;
    } else if (
      isChromium !== null &&
      typeof isChromium !== 'undefined' &&
      vendorName === 'Google Inc.' &&
      isOpera === false &&
      isIEedge === false
    ) {
      // is Google Chrome
      return true;
    } else {
      // not Google Chrome
    }
    return false;
  }
}
